import React, { CSSProperties, useState, FC } from 'react';
import { CardImageProps, ImageContainer } from '../types';

interface ExtendedCardImageProps extends CardImageProps {
  ratio?: string;
  customStyle?: CSSProperties;
}

const ResponsiveImage: FC<ExtendedCardImageProps> = ({
  webpUrl,
  jpgUrl,
  originalUrl,
  alt,
  title,
  classes,
  ratio,
  customStyle,
}) => {
  const [errorCount, setError] = useState(0);

  const safeTitle = title?.replace(/["]+/g, '');
  const safeAlt = alt?.replace(/["]+/g, '');

  return errorCount < 2 ? (
    <picture className={classes} title={safeTitle} style={customStyle}>
      {webpUrl && errorCount === 0 ? (
        <source srcSet={webpUrl} type='image/webp' />
      ) : null}
      {jpgUrl && errorCount < 2 ? (
        <source srcSet={jpgUrl} type='image/jpeg' />
      ) : null}
      <img
        src={originalUrl}
        className={classes}
        title={safeTitle}
        alt={safeAlt}
        loading='lazy'
        onError={() => setError(errorCount + 1)}
        {...getWidthAndHeight(ratio)}
      />
    </picture>
  ) : null;
};

const getWidthAndHeight = (ratio: string | undefined) => {
  switch (ratio) {
    case 'w45h28':
      return {
        width: 450,
        height: 280,
      };
    case 'w31h40':
      return {
        width: 310,
        height: 400,
      };
    case 'w427h400':
      return {
        width: 427,
        height: 400,
      };
    case 'w17h5':
      return {
        width: 1360,
        height: 400,
      };
    case 'w33h20':
      return {
        width: 660,
        height: 400,
      };
    case 'w7h5':
      return {
        width: 700,
        height: 500,
      };
    case 'flag':
      return {
        width: 32,
        height: 23,
      };
    case 'map':
      return {
        width: 100,
        height: 120,
      };
    default:
      return {};
  }
};

export class ImgContainer extends React.PureComponent<ImageContainer, {}> {
  render() {
    const { children, cropRatio, classes } = this.props;
    return (
      <div className={`ratio-container ratio-${cropRatio} ${classes ?? ''}`}>
        <div className='ratio-inner'>{children}</div>
      </div>
    );
  }
}

export default ResponsiveImage;
